import { useEffect, useState } from "react";

import { surveyRequests } from "@/api/(requests)/survey";

export const useCheckNPS = (surveyType) => {
  const [shouldShowNPS, setShouldShowNPS] = useState(false);

  const recordAnswer = () => {
    setShouldShowNPS(false);
  };

  const checkSurvey = async () => {
    const result = await surveyRequests.check_survey({
      context: { showLoader: false },
      data: {
        survey_type: surveyType,
      },
    });

    setShouldShowNPS(result.show_survey);
  };

  useEffect(() => {
    checkSurvey();
  }, []);

  return {
    recordAnswer,
    shouldShowNPS,
  };
};
